import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WEB_COMPONENT_GZ_ISOLATE_ENDPOINT_TASK } from '../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../utils/translator.helper';
import { FontSizes } from '../../../../../../types/common/types';

/**
 * @summary Content of Isolate Endpoint task pop-up.
 * @tag gz-isolate-endpoint-task
 */
@customElement(WEB_COMPONENT_GZ_ISOLATE_ENDPOINT_TASK)
export class GzIsolateEndpointTaskWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`<gz-text fontSize="${FontSizes.HEADING_6}">
      ${translateFn('The selected endpoint will be disconnected from the network.')}
    </gz-text>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    WEB_COMPONENT_GZ_ISOLATE_ENDPOINT_TASK: GzIsolateEndpointTaskWebComponent;
  }
}
